export default "__VITE_PUBLIC_ASSET__3ddf2778__"